import { defaultTheme } from 'react-admin';
import merge from 'lodash/merge';

export const SkybusTheme = merge({}, defaultTheme, {
    palette: {
        secondary: { main: "#ee3124" }
    }
});